import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';

export interface DLOTabItem {
  id: string;
  label: string;
}

interface DLOTabNavigationProps {
  tabs: DLOTabItem[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
  style?: any;
}

const DLOTabNavigation: React.FC<DLOTabNavigationProps> = ({
  tabs,
  activeTabId,
  onTabChange,
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      <View style={styles.tabsContainer}>
        {tabs.map((tab, index) => (
          <TouchableOpacity
            key={tab.id}
            style={[
              styles.tab,
              activeTabId === tab.id ? styles.activeTab : styles.inactiveTab,
            ]}
            onPress={() => onTabChange(tab.id)}
            activeOpacity={0.7}
          >
            <View style={styles.tabContent}>
              <Text
                style={[
                  styles.tabText,
                  activeTabId === tab.id ? styles.activeTabText : styles.inactiveTabText,
                ]}
              >
                {tab.label}
              </Text>
            </View>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginTop: 15,
  },
  tabsContainer: {
    flexDirection: 'row',
  },
  tab: {
    minHeight: 32,
    overflow: 'hidden',
    alignItems: 'center',
    flexDirection: 'row',
    borderStyle: 'solid',
  },
  activeTab: {
    borderBottomWidth: 2,
    borderBottomColor: '#005CBC',
  },
  inactiveTab: {
    borderBottomWidth: 1,
    borderBottomColor: '#D7E5F8',
  },
  tabContent: {
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignItems: 'center',
    flexDirection: 'row',
  },
  tabText: {
    textAlign: 'center',
    lineHeight: 20,
    fontSize: 14,
    color: '#616161',
  },
  activeTabText: {
    fontWeight: '700',
    color: '#005CBC',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  inactiveTabText: {
    fontWeight: '400',
    color: '#616161',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
});

export default DLOTabNavigation;
